<template>
  <div class="users">
    <v-container fluid>
      <v-row v-if="items">
        <v-col
          v-for="(item, index) in items"
          :key="index"
          :cols="12 / columns"
          :class="index < items.length - 1 ? 'pa-2 pb-0' : 'pa-2'"
        >
          <v-card outlined flat>
            <v-card-text class="pa-0">
              <v-list color="transparent" class="pa-0" three-line>
                <v-list-item>
                  <v-badge
                    :color="item.gender == '女' ? 'error' : 'primary'"
                    :icon="
                      item.gender == '女'
                        ? 'mdi-gender-female'
                        : 'mdi-gender-male'
                    "
                    offset-x="24"
                    offset-y="16"
                    right
                    overlap
                    bordered
                  >
                    <v-sheet
                      color="grey lighten-2 rounded"
                      width="72"
                      class="mr-3"
                    >
                      <v-img
                        :src="
                          item.imageUrl
                            ? utils.checkFile(item.imageUrl)
                            : defaultAvatar
                        "
                        class="rounded"
                        height="72"
                        max-width="72"
                        :aspect-ratio="3 / 2"
                        contain
                      >
                        <v-chip
                          v-if="!item.author"
                          @click="fnClaim(item)"
                          color="secondary"
                          label
                          class="rounded-0 px-2"
                          small
                          absolute
                        >
                          {{ hasUserInfo ? "认领" : "未认领" }}
                          <!-- <v-icon>mdi-key-variant</v-icon> -->
                        </v-chip>
                      </v-img>
                    </v-sheet>
                  </v-badge>
                  <v-list-item-content class="py-2 align-self-start">
                    <v-list-item-title class="d-flex align-center">
                      <v-chip
                        v-if="item.rank == '专家'"
                        color="error"
                        class="px-1 mr-1"
                        x-small
                      >
                        专
                      </v-chip>
                      {{ item.title }}
                      <v-chip
                        v-if="item.lastModifiedDate"
                        color="transparent"
                        class="ml-2 px-0 grey--text"
                        label
                        small
                      >
                        <v-icon class="mr-1"> mdi-refresh </v-icon>
                        {{ moment(item.lastModifiedDate).fromNow() }}
                      </v-chip>
                      <v-chip
                        color="transparent"
                        class="ml-2 px-0 grey--text"
                        label
                        small
                      >
                        <v-icon class="mr-1">mdi-eye</v-icon>
                        {{ item.hits }}
                      </v-chip>
                      <v-spacer></v-spacer>
                      <v-btn @click="fnTreatise(item)" icon small>
                        <v-icon small
                          >mdi-file-document-multiple-outline</v-icon
                        >
                      </v-btn>
                      <v-btn @click="fnView(item)" icon small>
                        <v-icon small
                          >mdi-badge-account-horizontal-outline</v-icon
                        >
                      </v-btn>
                    </v-list-item-title>
                    <v-list-item-subtitle v-if="item.profTitle" class="mb-1">
                      <v-chip
                        v-for="(chip, i) in item.profTitle.split(',')"
                        :key="i"
                        @click="fnKeywords(chip)"
                        :value="chip"
                        color="grey lighten-2"
                        class="mr-1"
                        label
                        small
                      >
                        {{ chip }}
                      </v-chip>
                    </v-list-item-subtitle>
                    <v-list-item-subtitle v-if="item.profSkill">
                      <v-chip
                        v-for="(chip, i) in item.profSkill.split(',')"
                        :key="i"
                        @click="fnKeywords(chip)"
                        :value="chip"
                        color="primary"
                        class="mb-1 mr-1"
                        label
                        small
                      >
                        {{ chip }}
                      </v-chip>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
            <v-card-actions class="pt-0 text-truncate">
              <v-chip @click="fnSetOrg(item)" color="transparent" label small>
                {{ item.channelName }}
              </v-chip>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-bottom-sheet v-model="detail" class="fullscreen">
      <v-card
        v-if="currentItem"
        @click="detail = false"
        color="grey lighten-4"
        class="pb-6"
        outlined
        tile
        flat
      >
        <v-card-title>
          {{ currentItem.name }}
          <v-spacer></v-spacer>
          <v-chip
            v-if="currentItem.ethnicGroup"
            @click="fnKeywords(currentItem.ethnicGroup)"
            color="primary lighten-2"
            class="ml-2"
            label
            small
          >
            {{ currentItem.ethnicGroup }}
          </v-chip>
          <v-chip
            v-if="currentItem.politics"
            @click="fnKeywords(currentItem.politics)"
            color="error lighten-2"
            class="ml-2"
            label
            small
          >
            {{ currentItem.politics }}
          </v-chip>
        </v-card-title>
        <v-card-subtitle
          :class="
            currentItem.department || currentItem.jobTitle
              ? 'pt-1 pb-0'
              : 'pt-1'
          "
        >
          {{ currentItem.org }}
        </v-card-subtitle>
        <v-card-subtitle
          v-if="currentItem.department"
          :class="currentItem.jobTitle ? 'py-1' : 'pt-1'"
        >
          {{ currentItem.department }}
        </v-card-subtitle>
        <v-card-subtitle v-if="currentItem.jobTitle" class="pt-1">
          <v-chip
            v-for="tag in utils.setArray(currentItem.jobTitle)"
            :key="tag"
            color="warning"
            class="ma-0 mr-1 py-0"
            label
            small
          >
            {{ tag }}
          </v-chip>
        </v-card-subtitle>
        <v-sheet color="grey lighten-2">
          <v-img
            :src="
              currentItem.imageUrl
                ? utils.checkFile(currentItem.imageUrl)
                : defaultAvatar
            "
            :aspect-ratio="3 / 2"
            class="mb-3"
            contain
          >
          </v-img>
        </v-sheet>
        <template v-for="(val, key, index) in currentItem">
          <v-card-text
            v-if="typeof val == 'object'"
            :key="index"
            class="d-flex justify-space-between pa-1 px-6"
          >
            <div class="key font-weight-bold" v-text="val.label"></div>
            <div v-if="val.value">
              <v-chip
                v-for="tag in utils.setArray(val.value)"
                :key="tag"
                @click="fnKeywords(tag)"
                class="ma-0 ml-1 py-0"
                label
                small
              >
                {{ tag }}
              </v-chip>
            </div>
            <div v-else class="grey--text">-</div>
          </v-card-text>
        </template>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
import moment from "moment";
// 自定义设置
import config from "@/utils/config";
// 自定义功能
import utils from "@/utils";
export default {
  name: "CUsers",
  props: {
    items: { type: Array, required: false, default: () => [] },
    columns: { type: Number, required: false, default: 1 },
  },
  data: () => ({
    utils: utils,
    moment: moment,
    detail: false,
    currentItem: null,
    defaultAvatar: null,
    hasUserInfo: false,
    userInfo: null,
  }),
  computed: {},
  created() {
    this.init();
  },
  methods: {
    init() {
      moment.locale("zh-cn");
      this.defaultAvatar = require("@/assets/images/logo.png");
      var userInfo = utils.fnStorage.get("khesUserInfo");
      if (userInfo) {
        this.hasUserInfo = true;
        this.userInfo = userInfo;
      }
    },
    fnView(item) {
      moment.locale("zh-cn");
      this.currentItem = {
        name: item.title,
        ethnicGroup: item.ethnicGroup,
        politics: item.politics,
        org: item.channelName,
        department: item.department,
        jobTitle: item.jobTitle,
        imageUrl: item.imageUrl,
        // age: {
        //   label: "年龄",
        //   value: moment().diff(moment(item.birthday), "years"),
        // },
        certNo: { label: "会员证号", value: item.certNo },
        profTitle: { label: "职称", value: item.profTitle },
        profSkill: { label: "专长", value: item.profSkill },
        qualification: { label: "学历", value: item.qualification },
        degree: { label: "学位", value: item.degree },
        school: { label: "毕业学校", value: item.school },
      };
      this.detail = true;
      // 统计点击量
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src = `${config.baseUrl}${config.baseDir}/api/hits/${item.siteId}/${item.channelId}/${item.id}`;
      document.head.appendChild(script);
    },
    fnTreatise(item) {
      this.$emit("setTreatise", item);
    },
    fnKeywords(item) {
      this.$emit("setKeywords", item);
    },
    fnSetOrg(item) {
      this.$emit("setOrg", item);
    },
    fnClaim(item) {
      this.$emit("setClaim", item);
    },
  },
};
</script>
<style lang="scss" scoped>
.key {
  min-width: 4.2rem;
}
</style>